// extracted by mini-css-extract-plugin
export default {"root":"QO60Jq8NdscSc_neajXw"};